<template>
  <!--
    When loaded inside the partner-v2 iframe shell, hide the Vue layout
    (sidebar + navbar) and only render the page content.
    isEmbedded detects this by checking window !== window.top.
    We retain the layout-vertical component to preserve structural CSS wrappers
    like .app-content but we use a CSS class to hide the menus.
  -->
  <layout-vertical :class="{ 'is-embedded': isEmbedded }">
    <router-view />
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  components: {
    LayoutVertical,
  },
  setup() {
    // Gunakan window.name sebagai pengirim sinyal yang paling kebal terhadap Vue Router!
    // React shell membungkus iframe ini dengan name="forceLayout=true"
    const forceLayout = window.name === 'forceLayout=true'

    // Anggap tidak embedded jika forceLayout disuntikkan
    const isEmbedded = window !== window.top && !forceLayout

    const { isNavMenuHidden, navbarType, footerType } = useAppConfig()

    if (isEmbedded) {
      isNavMenuHidden.value = true
      navbarType.value = 'hidden'
      footerType.value = 'hidden'
    } else {
      // WAJIB: Kembalikan nilai ke default jika sebelumnya sempat disembunyikan
      // karena Vuexy sering menyimpan state ini ke localStorage (persistent)!
      isNavMenuHidden.value = false
      if (navbarType.value === 'hidden') navbarType.value = 'sticky'
      if (footerType.value === 'hidden') footerType.value = 'static'
    }

    return {
      isEmbedded,
    }
  },
}
</script>

<style>
/* CSS to hide navbars and sidebars when running inside React iframe */
.vertical-layout.is-embedded .header-navbar {
  display: none !important;
}

.vertical-layout.is-embedded .main-menu {
  display: none !important;
}

/* Adjust content padding so it doesn't leave space for the hidden sidebar/navbar */
html body .vertical-layout.is-embedded .app-content {
  margin-left: 0 !important;
  margin-top: 0 !important;
  padding-top: 1rem !important; /* Provide a small gap at the top to replace navbar gap */
}

/* Hide footer */
.vertical-layout.is-embedded footer.footer {
  display: none !important;
}

/* Adjust overlay */
.vertical-layout.is-embedded .sidenav-overlay {
  display: none !important;
}

/* Completely DESTROY the Vuexy dirty shadow gradient illusion */
.vertical-layout.is-embedded .main-menu,
.vertical-layout.is-embedded .header-navbar-shadow,
.vertical-layout.is-embedded .content-overlay {
  display: none !important;
  box-shadow: none !important;
}

/* FORCIBLY MAKE VUEXY WHITE to match the React sidebar, eliminating the grey area */
html body .vertical-layout.is-embedded,
html body .vertical-layout.is-embedded .content-wrapper,
html body .vertical-layout.is-embedded .content-area-wrapper,
html body .vertical-layout.is-embedded .app-content {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
</style>
